import actions from './actions';

const {
  GET_MONITOR_LOAD,
  GET_MONITOR_SUCCESS,
  GET_MONITOR_ERROR,
  ADD_MACHINE_BEGIN,
  ADD_MACHINE_SUCCESS,
  ADD_MACHINE_ERROR,
  GET_MACHINE_DATA_LOAD,
  GET_MACHINE_DATA_SUCCESS,
  GET_MACHINE_DATA_ERROR,
} = actions;

const initialState = {
  data: [],
  ams: [],
  loading: false,
  error: null,
};

const processedMachinesReducer = (state = initialState, action) => {
  const { type, raw, monitor, err } = action;

  switch (type) {
    case GET_MONITOR_LOAD:
      return { ...state, data: [], loading: true };

    case GET_MONITOR_SUCCESS:
      return { ...state, data: monitor, error: false, loading: false };

    case GET_MONITOR_ERROR:
      return { ...state, error: err, loading: false };

    case ADD_MACHINE_BEGIN:
      return { ...state, loading: true };

    case ADD_MACHINE_SUCCESS:
      return { ...state, raw, loading: true, error: false };

    case ADD_MACHINE_ERROR:
      return { ...state, error: err, loading: false };

    case GET_MACHINE_DATA_LOAD:
      return { ...state, ams: [], loading: true };

    case GET_MACHINE_DATA_SUCCESS:
      return { ...state, ams: raw, error: false, loading: false };

    case GET_MACHINE_DATA_ERROR:
      return { ...state, error: err, loading: false };

    default:
      return state;
  }
};

export { processedMachinesReducer };
